import {computed} from "vue";

//@ts-ignore
import {parsePoints, removeDuplicatePoints} from "@utils/MapUtils";
//@ts-ignore
import {encodeCookie} from "@utils/CookieUtils"
//@ts-ignore
import {buildURL, buildParams} from "@utils/RESBUrlBuilder/RESB_UrlBuilder"

//@ts-ignore
import {Nullable} from "@customTypes/CustomUtilityTypes";
//@ts-ignore
import {replaceAll} from "@utils/StringUtils";
//@ts-ignore
import {SelectOptions} from "@customTypes/BaseInputTypes";
//@ts-ignore
import {useSearchBeanStore} from "@store/SearchBeanStore";

type FreeSearchParams = {
    value: string
}


interface LatLng {
    lat: number;
    lng: number;
}


interface UsableSearch {
    search: (
        withRedirect?: boolean,
        customListingTypologyURL?: string,
        useContractType?: boolean,
        agencyFilterParameters?: any,
        freeSearch?: Nullable<FreeSearchParams>
    ) => string;
    setOrderAndSearch: (opt: SelectOptions<any>) => void;
    setOrderAndSearchInAgency: (opt: SelectOptions<any>) => void;
}

export function useSearch(): UsableSearch{
    const searchBeanStore = useSearchBeanStore()

    const search = (
        withRedirect = true, customListingTypologyURL = "", useContractType = true,
        agencyFilterParameters = null, freeSearch: Nullable<FreeSearchParams> = null
    ): string => {
        // eslint-disable-next-line max-len
        if ((!searchBeanStore.searchBean.cityURL && !searchBeanStore.searchBean.polygonFromMap && !agencyFilterParameters) ||
            !(searchBeanStore.searchBean.listingTypologyURL || customListingTypologyURL) ||
            (useContractType && !searchBeanStore.searchBean.contractType)) {
            if (!freeSearch) {
                console.error("cannot search");
                return "";
            }
        }

        let URL = "";

        if (freeSearch) {
            URL += "/cerca";
            // Andrea M: when new search the city must be empty without any filter
            // eslint-disable-next-line max-len
            URL += buildURL("", searchBeanStore.searchBean.listingTypologyURL || "", searchBeanStore.searchBean.contractType, searchBeanStore.searchBean.zoneURL, replaceAll(replaceAll(freeSearch.value, "[.]", ""), "\\s+", "-"));
            URL += buildParams(searchBeanStore.searchBean);
            if (URL && withRedirect)
                //@ts-ignore
                window.location.href = window._baseURL + URL;

            // @ts-ignore
            return window._baseURL + URL;
        }
        let cityURL;
        if (!searchBeanStore.searchBean?.cityURL && agencyFilterParameters)
            cityURL = "";
        else if (searchBeanStore.searchBean?.cityURL)
            cityURL = searchBeanStore.searchBean?.cityURL;
        else
            cityURL = "ricerca";

        let agencyUri;
        if (searchBeanStore.searchBean?.cityURL && agencyFilterParameters) {
            // @ts-ignore
            agencyUri = agencyFilterParameters.uri;
        }

        if (searchBeanStore.searchBean.zoneIdList && searchBeanStore.searchBean.zoneIdList?.length > 0)
            URL = buildURL(
                cityURL,
                customListingTypologyURL ? customListingTypologyURL :
                    searchBeanStore.searchBean.listingTypologyURL || "",
                useContractType ? searchBeanStore.searchBean.contractType
                    : null,
                searchBeanStore.searchBean.zoneURL,
                undefined, agencyUri ?? "",
                null
            );
        else
            URL = buildURL(
                cityURL,
                customListingTypologyURL ? customListingTypologyURL :
                    searchBeanStore.searchBean.listingTypologyURL || "",
                useContractType ? searchBeanStore.searchBean.contractType
                    : null,
                searchBeanStore.searchBean.zoneURL,
                undefined, agencyUri ?? "",
                searchBeanStore.searchBean.districtURL
            );


        if (!customListingTypologyURL)
            URL += buildParams(searchBeanStore.searchBean);
        else if (agencyFilterParameters != null) {
            if (!searchBeanStore.searchBean?.cityURL && agencyFilterParameters)
                // @ts-ignore
                URL += agencyFilterParameters.uri ? agencyFilterParameters?.uri + "/" : "";
            // @ts-ignore
            URL += agencyFilterParameters.name ? `?Nome=${agencyFilterParameters.name}` : "";
        }
        let delimiter = URL.indexOf("?") > -1 ? "&" : "?";
        if (searchBeanStore.searchBean.polygonFromMap) {
            /*  Handling polygon arriving from backend with POLYGIN((***)) format */
            if (searchBeanStore.searchBean.polygonFromMap.indexOf("POLYGON") > -1) {
                const points = removeDuplicatePoints(parsePoints(searchBeanStore.searchBean.polygonFromMap) || []);
                if (points) {
                    searchBeanStore.searchBean.polygonFromMap = points.map((point: LatLng) => `${point.lat},${point.lng};`).join("");
                }
            }
            //@ts-ignore
            URL += `${delimiter}Poligono=${encodeURIComponent(searchBeanStore.searchBean.polygonFromMap)}`
        } else if (!searchBeanStore.searchBean.zoneURL && searchBeanStore.searchBean.zoneIdList && searchBeanStore.searchBean.zoneIdList.length > 1) {
            URL += `${delimiter}zoneID=${searchBeanStore.searchBean.zoneIdList.join("&zoneID=")}`;
        }


        if (searchBeanStore.searchBean.districtIdList &&
            (searchBeanStore.searchBean.districtIdList.length > 1 ||
                // eslint-disable-next-line max-len
                (searchBeanStore.searchBean.districtIdList.length === 1 && (searchBeanStore.searchBean.zoneIdList && searchBeanStore.searchBean.zoneIdList?.length >= 1 || searchBeanStore.searchBean.zoneId)))
        ) {
            delimiter = URL.indexOf("?") > -1 ? "&" : "?";
            URL += delimiter + "districtID=" + searchBeanStore.searchBean.districtIdList.join("&districtID=");
        }

        /* qui se ho più di un listing typology genero l`array */
        if (searchBeanStore.searchBean.listingTypologyIdList && searchBeanStore.searchBean.listingTypologyIdList.length > 1 && !customListingTypologyURL) {
            delimiter = URL.indexOf("?") > -1 ? "&" : "?";
            URL += delimiter + "listingTypologyID=" + searchBeanStore.searchBean.listingTypologyIdList.join("&listingTypologyID=");
        }


        encodeCookie("newSearch", true);

        if (URL && withRedirect)
            //@ts-ignore
            window.location.href = window._baseURL + URL;

        //@ts-ignore
        return window._baseURL + URL;
    }

    const setOrderAndSearch = (opt: SelectOptions<any>): void => {
        searchBeanStore.searchBean.filterOrderId = opt.id;
        search();
    }
    const setOrderAndSearchInAgency = (opt: SelectOptions<any>): void => {
        const urlSearchPar = new URLSearchParams(window.location.search);
        if (opt.id) {
            urlSearchPar.set("Ordinamento", String(opt.id));
        }
        window.location.href = location.protocol + "//" + location.host + "/" + location.pathname + "?" + urlSearchPar.toString();
    }
    return {
        search,
        setOrderAndSearch,
        setOrderAndSearchInAgency,
    }

}
